import axiosInstance from "../api/axiosInstance";

// GET: Promoter / venue promotion request list
export const fetchPromoterRequests = (params) =>
  axiosInstance.get("/admin/promoterRequestList", { params });

// PATCH/PUT: Approve or reject request
export const updatePromoterRequestStatus = (id, data) =>
  axiosInstance.patch(`/admin/promoterRequestStatus/${id}`, data);
